// extracted by mini-css-extract-plugin
module.exports = {"ResponsiveWrapper":"ResponsiveWrapper_ResponsiveWrapper__1Ur7_","Loading":"ResponsiveWrapper_Loading__SuvSx"};